import { injectable, inject } from 'inversify';
import type { IAuthRepository } from '@/domain/repositories/IAuthRepository';
import { Enable2FACommand } from '@/application/commands/auth/Enable2FACommand';
import { TYPES } from '@/di/tokens';

@injectable()
export class Enable2FAAction {
  constructor(
    @inject(TYPES.IAuthRepository) private authRepository: IAuthRepository
  ) {}

  async execute(command: Enable2FACommand): Promise<{ secret: string; qrCodeUrl: string }> {
    return await this.authRepository.enable2FA();
  }
}
